import React from 'react';
import { formatNumberToK } from '@/utils/helpers';
import { ReactComponent as CompleteIcon } from '@/assets/icons/completed.svg';
import { CircleXIcon } from 'lucide-react';
import { FileText } from 'lucide-react';

interface InvoiceUploadOverviewProps {
  invoiceImg: string | File;
  invoiceCompanyName: string;
  invoiceName: string;
  invoiceCategory: string;
  paymentCurrency: string;
  paymentAmount: number;
  paymentType: string;
}

const InvoiceUploadOverview = ({
  invoiceImg,
  invoiceCompanyName,
  invoiceName,
  invoiceCategory,
  paymentCurrency,
  paymentAmount,
  paymentType
}: InvoiceUploadOverviewProps) => {
  return (
    <div className="card hidden xl:flex flex-col items-center gap-[19px] py-5 px-6">
      <span className="w-[108px] h-[108px] border rounded-[16px] bg-lightPurple flex items-center justify-center">
        {invoiceImg && typeof invoiceImg === 'object' && invoiceImg.type.startsWith('image/') ? (
          <img
            src={typeof invoiceImg === 'string' ? invoiceImg : URL.createObjectURL(invoiceImg)}
            alt="Uploaded file"
            className="w-full h-full object-cover rounded-[16px]"
          />
        ) : (
          <span
            className="cursor-pointer"
            onClick={() => {
              if (typeof invoiceImg === 'object' && invoiceImg.type.startsWith('application/pdf')) {
                window.open(URL.createObjectURL(invoiceImg), '_blank');
              }
            }}
            title="View PDF"
          >
            <FileText className="w-16 h-16 object-cover rounded-[16px] text-lightPurple-200/80" />
          </span>
        )}
      </span>

      <div className="flex flex-col gap-[7px] items-center">
        <p className="text-sm text-secondary leading-[100%] text-center">{invoiceCompanyName || '-'}</p>
        <p className="text-base font-semibold leading-[100%]">{invoiceName || '-'}</p>
        <p className="text-sm text-secondary leading-[100%]">
          {invoiceCategory === 'expense' ? 'Expense' : 'Revenue'}{' '}
          <span className="text-primary font-bold"> &middot;</span> {paymentCurrency === 'EUR' ? '€' : '$'}
          {formatNumberToK(paymentAmount || '0')}
        </p>
      </div>
      <p className="text-base flex items-center gap-1 font-medium text-secondary leading-[100%]">
        <span>{paymentType === 'ALREADY_PAID' ? <CompleteIcon /> : <CircleXIcon className="w-[16px] h-[16px]" />}</span>
        <span>{paymentType === 'ALREADY_PAID' ? 'Paid' : 'Not Paid'}</span>
      </p>
    </div>
  );
};

export default InvoiceUploadOverview;
